import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Download, ReceiptText } from 'lucide-react';
import { API } from '@/App';
import { Button } from '@/components/ui/button';

const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

export const ReceiptsHistory = ({ title = 'Receipts' }) => {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    axios.get(`${API}/billing/receipts`, { headers: headers() }).then((r) => setRows(r.data || [])).catch(() => setRows([]));
  }, []);
  const download = async (r) => {
    try {
      const res = await axios.get(`${API}/billing/receipts/${r.id}/pdf`, { headers: headers(), responseType: 'blob' });
      const a = document.createElement('a');
      a.href = URL.createObjectURL(res.data);
      a.download = `${r.id}.pdf`;
      a.click();
    } catch {
      toast.error('Could not download receipt');
    }
  };
  return (
    <div className="lg-glass rounded-2xl border p-5" data-testid="receipts-history">
      <h3 className="font-semibold text-stone-900 flex items-center gap-2 mb-3"><ReceiptText size={18} /> {title}</h3>
      {rows === null ? <div className="h-16 rounded-xl bg-stone-100 animate-pulse" /> : rows.length === 0 ? (
        <p className="text-sm text-stone-500" data-testid="receipts-empty">No receipts yet. They appear here automatically after each payment.</p>
      ) : (
        <div className="divide-y divide-stone-100">
          {rows.map((r) => (
            <div key={r.id} className="flex flex-wrap items-center gap-3 py-2.5 text-sm" data-testid={`receipt-row-${r.id}`}>
              <span className="font-mono font-semibold text-stone-900">{r.id}</span>
              <span className="text-stone-500">{String(r.paid_on || r.created_at || '').slice(0, 10)}</span>
              <span className="text-stone-700 flex-1 min-w-[160px] truncate">{r.purpose || (r.kind === 'subscription' ? 'Subscription' : 'Payment')}</span>
              <span className="font-mono font-semibold">₹{Number(r.amount || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}</span>
              <Button size="sm" variant="outline" onClick={() => download(r)} data-testid={`receipt-download-${r.id}`}><Download size={13} className="mr-1" /> PDF</Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
